// type Line2 = [Vec2, Vec2];
function normalize(v) {
    const len = Math.hypot(v[0], v[1]);
    return [v[0] / len, v[1] / len];
}
function sub(a, b) {
    return [a[0] - b[0], a[1] - b[1]];
}
function add(a, b) {
    return [a[0] + b[0], a[1] + b[1]];
}
function mul(v, s) {
    return [v[0] * s, v[1] * s];
}
function cross(a, b) {
    return a[0] * b[1] - a[1] * b[0];
}
function intersectLines(l1, l2) {
    const p = l1[0];
    const r = sub(l1[1], l1[0]);
    const q = l2[0];
    const s = sub(l2[1], l2[0]);
    const rxs = cross(r, s);
    if (Math.abs(rxs) < 1e-8)
        return null;
    const t = cross(sub(q, p), s) / rxs;
    return add(p, mul(r, t));
}
export function calcExtendForOffsetLine(line1, line2, h) {
    const A = line1[0];
    const B = line1[1];
    const dirRaw = sub(B, A);
    const length = Math.hypot(dirRaw[0], dirRaw[1]);
    const dir = [dirRaw[0] / length, dirRaw[1] / length];
    const normal = normalize([-dir[1], dir[0]]);
    const lower = [
        add(A, mul(normal, -h / 2)),
        add(B, mul(normal, -h / 2))
    ];
    const intersection = intersectLines(lower, line2);
    if (!intersection)
        return 0;
    const AP = sub(intersection, lower[0]);
    const t = AP[0] * dir[0] + AP[1] * dir[1];
    if (t > length) {
        return t - length;
    }
    if (t < 0) {
        return -t;
    }
    return 0; // уже пересекается внутри
}
